module.exports = __webpack_public_path__ + "static/media/motel-lasvegas.e1af5b33.jpg";